import styled from 'styled-components'
import CoverLetterImage from './assets/illustration.png'

export const Image = styled.div`
  width: 100%;
  height: 100%;
  background-image: url(${CoverLetterImage});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`
